// import * as mns from '../../../../mutation-types';

export default {
    state () {
        return {
        }
    },
    getters: {
    },
    mutations: {
    }
} // export.